import { useCallback } from 'react';

import { type Board, type Clip } from '@air/api/types';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type AirActionTrackingLocation } from '../types';

export type TrackCreatedBoardParams = Pick<Board, 'id' | 'title' | 'description'> & {
  clipIds?: Clip['id'][];
  location: AirActionTrackingLocation;
};

export const useTrackCreatedBoard = () => {
  const { track } = useAnalyticsUtilities();

  const trackCreatedBoard = useCallback(
    (params: TrackCreatedBoardParams) => {
      track(`Created a board`, params, { integrations: { 'Customer.io (Actions)': true, Intercom: true } });
    },
    [track],
  );

  return { trackCreatedBoard };
};
